import { Container } from '@mui/material';
import React from 'react';

export class NotFound extends React.Component {
    public render(): React.ReactNode {
        return (
            <Container>
                <h2>Page Not Found</h2>
                <p>The page you are trying to open does not exist. Please check the URL and try again</p>
            </Container>
        );
    }
}
